import { motion } from "motion/react";

/**
 * Shown only after every page of Review is loaded (no more scroll pages).
 * Explains that Accept / Reject / Skip frees pending space for new AI drafts.
 */
export default function PromoteSurfaceReviewBatchFooter() {
  return (
    <motion.aside
      role="status"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.25, ease: [0.22, 1, 0.36, 1] }}
      className="mx-auto mt-8 mb-3 flex max-w-md flex-col items-center gap-3 px-4 text-center"
    >
      <div className="flex w-full items-center gap-3" aria-hidden>
        <span className="h-px flex-1 bg-border/80" />
        <span className="size-1.5 shrink-0 rounded-full bg-muted-foreground/40" />
        <span className="h-px flex-1 bg-border/80" />
      </div>

      <div className="space-y-1.5">
        <h3 className="text-sm font-medium tracking-tight text-foreground">
          You’ve seen everything in Review for now
        </h3>
        <p className="text-[13px] leading-relaxed text-muted-foreground">
          There’s nothing more to scroll. As you{" "}
          <span className="font-medium text-foreground">Accept</span>,{" "}
          <span className="font-medium text-foreground">Reject</span>, or{" "}
          <span className="font-medium text-foreground">Skip</span> these images, new AI drafts can
          refill this section.
        </p>
      </div>
    </motion.aside>
  );
}
